import { PermissionString } from "@/types"

/**
 * @param {string} url - Url to build
 * @param {object} params - Object to replace in url
 * @returns {string} - Return url with params replaced
 */
export function buildUrl(url: string, params: Record<string, any> = {}) {
  let result = url

  for (let key of Object.keys(params)) {
    result = result.replace(new RegExp(`{${key}}`), params[key])
  }

  return result
}

export function normalizePathname(path: string) {
  return path.replace(/(\/\{[^}]+}|\?.*$)/g, "")
}

export function parseObjectToFormData(object: Record<string, unknown>, formData = new FormData(), parentKey = "") {
  if (object && typeof object === "object" && !(object instanceof File) && !(object instanceof Blob)) {
    Object.keys(object).forEach((key) => {
      const value = object[key]
      const newKey = parentKey ? `${parentKey}[${key}]` : key

      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          const arrayKey = `${newKey}[${index}]`

          parseObjectToFormData({ [arrayKey]: item }, formData)
        })
      } else {
        parseObjectToFormData(value as Record<string, unknown>, formData, newKey)
      }
    })
  } else {
    formData.append(parentKey, object)
  }

  return formData
}

export function convertPermissionToMappedPermission(
  permissions: PermissionString[]
): Partial<Record<PermissionString, boolean>> {
  return permissions.reduce(
    (acc, permission) => {
      acc[permission] = true

      return acc
    },
    {} as Partial<Record<PermissionString, boolean>>
  )
}
